import React from 'react';
import { Link } from "react-router-dom";

const Hero = () => (
  <section id="hero" className="relative h-screen overflow-hidden">
    {/* background image */}
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{
        backgroundImage:
          "url('/imagem/capa-home-clara.png')" // teste com capa mais clara
      }}
    />
    {/* blue overlay over entire background to darken layout */}
    <div className="absolute inset-0 bg-blue-900/50" />
    {/* optional soft inner shadow to darken edges */}
    <div className="absolute inset-0 shadow-inner" />

    {/* main content centered and closer to header */}
    <div className="relative z-10 flex items-center justify-center h-full px-4 sm:px-8">
      <div className="text-center max-w-2xl w-full">
        <h1 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-center">
          <span className="block">Fortalecendo a Engenharia</span>
          <span className="block text-secondary-light">Agronômica em Goiás</span>
        </h1>
        <p className="mt-4 text-white/80 text-lg font-semibold drop-shadow-md">
          Desde 1965, promovendo o desenvolvimento profissional e a valorização dos engenheiros agrônomos goianos.
        </p>
        <div className="mt-8 flex justify-center space-x-4">
          <a
            href="https://forms.gle/19xC5cN8AdDZC2r76"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-navy font-semibold py-3 px-6 rounded-full hover:bg-gray-100 transition"
          >
            Associe-se
          </a>
          <Link
            to="/#contato"
            className="inline-block border-2 border-white text-white font-semibold py-3 px-6 rounded-full hover:bg-white hover:text-navy transition"
          >
            Saiba mais
          </Link>
        </div>
      </div>
    </div>

    {/* hero content remains unchanged, navigation moved to header component */}

    {/* scroll indicator */}
    <div className="absolute bottom-8 w-full flex justify-center z-10">
      <Link
        to="/#about"
        className="text-white animate-bounce"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </Link>
    </div>
  </section>
);

export default Hero;
